"use client"

import Text from "@/components/common/Typography/Text"
import { Card, Col, Row, Skeleton } from "antd"

type SelectPlacementSkeletonProps = {
  size?: 'small' | 'default',
  isPopup?: boolean,
}

// SELECT PLACEMENTS COMPONENTS
const SelectPlacementSkeleton = ({ isPopup = true, size = 'default' }: SelectPlacementSkeletonProps) => {

  const isSmall = size === 'small'

  const content = (
    <>
      {/* <DomesticAirports />
      <InternationalAirports />
      <ResultAirports />
      <SearchingResults /> */}
    </>
  )

  const popup = (
    <Card
      size='small'
      className="home__searching--placement"
    >
      <Row className="home__searching--input-label" align='middle' gutter={[5, 5]} wrap={false}>
        <Col style={isSmall ? { height: '2rem' } : {}}>
          <Skeleton.Button
            active
            styles={{
              content: {
                width: isSmall ? '2rem' : '2.5rem',
                minWidth: isSmall ? '2rem' : '2.5rem',
                height: isSmall ? '2rem' : '2.55rem'
              }
            }}
          />
        </Col>
        <Col style={isSmall ? { height: '2rem' } : {}}>
          <Skeleton
            active
            styles={{
              title: {
                width: '7.7rem',
                height: isSmall ? '2rem' : '2.2rem',
                margin: 0
              }
            }}
            paragraph={false}
          />
        </Col>
      </Row>
      <Row style={isSmall ? { marginTop: 5, height: '2.1rem' } : { marginBlock: '0.5rem' }}>
        <Col span={24} style={isSmall ? { height: '2.1rem' } : {}}>
          <Skeleton.Input style={isSmall ? { height: '2.1rem' } : {}} block active size={isSmall ? 'default' : 'large'} />
        </Col>
      </Row>
      {size === 'default' && (
        <Row>
          <Skeleton
            paragraph={false}
            active
            styles={{
              title: {
                margin: 0,
                height: '2.5rem'
              }
            }}
          />
        </Row>
      )}
    </Card>
  )

  return isPopup ? popup : content
}

export default SelectPlacementSkeleton